import {
    addBillingAddress,
    addShippingAddress,
    applyGiftcard,
    cleanCost,
    getShippingMethods,
    recalculateCart,
    removeGiftcard,
    removePaymentCost,
    replicateCart,
    setPaymentCost,
    setShippingCost,
    validateCart,
} from "@/lib/jog"
import { CartStore } from "@jog/react-components"

const cartStore = new CartStore({
    api: {
        recalculateCart,
        addBillingAddress,
        addShippingAddress,
        getShippingMethods,
        setShippingCost,
        applyGiftcard,
        removeGiftcard,
        replicateCart,
        setPaymentCost,
        removePaymentCost,
        validateCart,
        cleanCost,
    },
})

export default cartStore
